/**
 * @generated SignedSource<<9fd95210a3543ee41d4cf601829b9166>>
 * @relayHash 54f53df9c971403cebb9ceaed9ca1232
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0fa9669b974f688d91987636bbf14d3c1803a4bc062e179d0a09931e8f04d500

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraRemoveIssuesFromAllFixVersionsInput = {
  issueIds: ReadonlyArray<string>;
};
export type useRemoveIssuesFromAllVersionsMutation$variables = {
  boardId: string;
  input: JiraRemoveIssuesFromAllFixVersionsInput;
};
export type useRemoveIssuesFromAllVersionsMutation$data = {
  readonly jira: {
    readonly removeIssuesFromAllFixVersions: {
      readonly issueUpdateResults: ReadonlyArray<{
        readonly issueId: string;
        readonly updated: boolean;
      }> | null | undefined;
      readonly success: boolean;
      readonly versions: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"content_softwareVersionBacklogPanelRelay_jiraVersionFragment">;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useRemoveIssuesFromAllVersionsMutation = {
  response: useRemoveIssuesFromAllVersionsMutation$data;
  variables: useRemoveIssuesFromAllVersionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "JiraVersionIssueUpdateResult",
  "kind": "LinkedField",
  "name": "issueUpdateResults",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "kind": "ScalarField",
      "name": "updated"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useRemoveIssuesFromAllVersionsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
            "kind": "LinkedField",
            "name": "removeIssuesFromAllFixVersions",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "content_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useRemoveIssuesFromAllVersionsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
            "kind": "LinkedField",
            "name": "removeIssuesFromAllFixVersions",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "versionId"
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "startDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "releaseDate"
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                      }
                    ],
                    "concreteType": "JiraVersionStatistics",
                    "kind": "LinkedField",
                    "name": "statistics",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "doneEstimate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalEstimate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "percentageCompleted"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "notEstimated"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "done"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalIssueCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "toDo"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "inProgress"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v6/*: any*/),
                      {
                        "alias": "editProjectConfig",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canPerform"
                          }
                        ],
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0fa9669b974f688d91987636bbf14d3c1803a4bc062e179d0a09931e8f04d500",
    "metadata": {},
    "name": "useRemoveIssuesFromAllVersionsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d60aafd65f63c4583af72cc4c256ebbf";

export default node;
